import React from "react";
import { Col, Container, Row} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./BannerStyle.scss";
const OboutImage = require("../../../Assets/Images/canva/bussiness.png");
const Bussiness = () => {
  let { t } = useTranslation();
  return (
    <section id="canvaBusiness" className="BannerImgThree">
      <Container fluid className="h-100">
        <Row className="align-items-center h-100 px-4">
          <Col md={6} sm={12}>
            <div className="h-100">
            
                <h3 className="heading mt-5">
                  {/* {t("AboutUs")} */}
                  How Do Businesses Benefit From Cashless Tipping?
                </h3>
                <p className="py-2 canvaText">
                  {/* {t("AboutUsTextFirst")} */}
                  Maximize tips instantly with EasyTipping's cashless system.
                  Track and report earnings effortlessly for tax purposes.
                </p>
                <p className="py-2 canvaText">
                  {/* {t("AboutUsText2nd")} */}
                  Cashless tipping fosters transparency, trust, and loyalty,
                  enhancing employee performance tracking.
                </p>
                <p className="py-2 canvaText">
                  {/* {t("AboutUsText2nd")} */}
                  Digitize tip payouts to streamline payments, saving management
                  hours weekly.
                </p>
              </div>
         
          </Col>
          <Col md={6} sm={12}>
            <div className="h-100 w-100 text-center">
              <img className="img-fluid mx-100" src={OboutImage} alt="" />
            </div>
          </Col>
          {/* <Col md={6} sm={12}>
            <div className=" image w-100 text-center">
              <img className="img-fluid mx-100" src={OboutImage} alt="" />
            </div>
          </Col> */}
        </Row>
      </Container>
    </section>
  );
};

export default Bussiness;
